import {PatientTherapySequence} from '@cypro/engine/schema'
import {dialog} from '@cypro/ui/components'
import {Suspense} from 'react'
import {ManualAdministerDialog} from './manual-administer-dialog'

export function openManualAdministerDialog(sequence: PatientTherapySequence) {
  return dialog.open('manual-administer-dialog', {
    id: 'manual-administer-dialog',
    children: (
      <Suspense fallback={null}>
        <ManualAdministerDialog sequence={sequence} />
      </Suspense>
    ),
  })
}

export function closeManualAdministerDialog() {
  dialog.close('manual-administer-dialog', true)
}
